export default __webpack_public_path__ + "static/media/547.9b0a8a12.jpg";